module.exports = __webpack_public_path__ + "static/media/5.e49566e1.jpg";